import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Table, Button, Badge } from 'react-bootstrap';
// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';

// icon
import Icon from '@mdi/react';
import { mdiTrashCanOutline } from '@mdi/js';
import invoicesTableData from "./view-invoices-table-data.json";
import ViewInvoice from '../../../Utils/ViewInvoice';
import { showAlert } from '../../../Utils/utils';
import { toast } from 'react-toastify';

export default function ViewInvoices() {
    // TODO: implimentation of this function gloabally or in utility
    const getStatusFromStatusID = (id) => {
        let status, color;
        switch (id) {
            case 0:
                status = "Pending";
                color = "danger";
                break;

            case 1:
                status = "";
                color = "";
                break;

            case 2:
                status = "";
                color = "";
                break;

            default:
                status = "";
                color = "";
                break;
        }

        return [status, color];
    };

    const HandlePIDelete = (POID) => {
        try {
            showAlert('Do you really want to delete this record?', 'confirm', async (result) => {
                if (result) {
                    // try {
                    //     const response = await deleteFromAPI(`FtsPurchaseOrderInvoice/${POID}/`);
                    //     if (response.status) {
                    //         toast.success('Purchase invoice deleted successfully', 'success');
                    //         FetchPIData();
                    //         UpdateDataTable();
                    //     }
                    // } catch (error) {
                    //     console.error('Error deleting purchase invoice:', error);
                    //     toast.error('purchase invoice Not Deleted', 'error');
                    // }
                }
            }, { confirmButtonText: 'Delete', cancelButtonText: 'Cancel', title: 'Are you sure?', confirmButtonColor: '#dc3545' });
        } catch (error) {
            console.error('Error deleting purchase invoice:', error);
            toast.error('Error deleting purchase invoice', 'error');
        }
    }
    DataTable.Buttons.jszip(JSZip);
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    useEffect(() => {
        if (!$.fn.dataTable.isDataTable('#mainDatatableViewInvoices')) {
            $('#mainDatatableViewInvoices').DataTable({
                dom: "Bflrtip",
                data: invoicesTableData.invoiceListData.map(row => [
                    row.invoice_number,
                    row.date,
                    row.customer_name,
                    row.total,
                    row.amtPaid,
                    row.amtDue,
                    row.status,
                    row.paymentType,
                    row.id
                ]),
                columns: [
                    { title: "Invoice#" },
                    { title: "Date" },
                    { title: "Customer" },
                    { title: "Total" },
                    { title: "Amt Paid" },
                    { title: "Amt Due" },
                    {
                        title: "Status",
                        render: function (data, type, row) {
                            const [status, color] = getStatusFromStatusID(0);
                            return (`<span class="badge bg-soft-${color}" >${status}</span>`)
                        }
                    },
                    { title: "Payment Type" },
                    {
                        title: "Action",
                        createdCell: function (td) {
                            // Add a class to the 'Action' column cells
                            td.classList.add('py-1');
                        },
                        render: function (data, type, row) {
                            return `
                        <div class='btn-list d-flex'>
                            <button class="btn btn-light btn-sm invc-viewinvoice" data-invc_id="${row[5]}">View Invoice</button>
                            <button class="btn btn-light btn-sm" onClick="">Edit Invoice</button>
                            <button class="btn btn-light btn-sm" onClick="">Print</button>
                            <button class="btn btn-soft-danger btn-sm px-3 ms-auto invc-delete" data-invc_id="${row[5]}">
                            <svg viewBox="0 0 24 24" role="presentation" class="icon-size-16"><path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" style="fill: currentcolor;"></path></svg>
                            </button>
                        </div>
                      `;
                        }
                    }
                ],
                autoWidth: false,
                buttons: [
                    {
                        extend: 'excel',
                        className: 'btn btn-outline-secondary',
                        text: '<svg viewBox="0 0 24 24" role="presentation" class="btn-icon me-1"><path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.9 14.5L15.8 19H14L12 15.6L10 19H8.2L11.1 14.5L8.2 10H10L12 13.4L14 10H15.8L12.9 14.5Z" style="fill: currentcolor;"></path></svg> Export to Excel'
                    },
                    {
                        extend: 'pdf',
                        className: 'btn btn-outline-secondary',
                        text: '<svg viewBox="0 0 24 24" role="presentation" class="btn-icon me-1"><path d="M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z" style="fill: currentcolor;"></path></svg> Export to Pdf'
                    }
                ],
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });
            document.querySelector('#mainDatatableViewInvoices tbody').addEventListener('click', function (event) {
                // Check if the click happened inside a button with class 'invc-delete'
                const deleteButton = event.target.closest('.invc-delete');
                if (deleteButton) {
                    const pi_id = deleteButton.getAttribute('data-invc_id');
                    HandlePIDelete(pi_id);
                }
                // Check if the click happened inside a button with class 'invc-viewinvoice'
                const viewInvoiceButton = event.target.closest('.invc-viewinvoice');
                if (viewInvoiceButton) {
                    const pi_id = viewInvoiceButton.getAttribute('data-invc_id');
                    handleShowInvoice(pi_id);
                }
            });
        }

        if (document.getElementsByClassName("dt-buttons").length) {
            document.getElementById("mainDatatableViewInvoices_wrapper").classList.add("dtl-right");
        } else {
            document.getElementById("mainDatatableViewInvoices_wrapper").classList.remove("dtl-right");
        }
    }, []);

    // Invoice Data
    const fromInfoData = [
        { label: 'INVOICE#', value: 'Oct0002' },
        { label: 'Date', value: '24-10-2024' },
        { label: 'Vendor Name', value: 'Jems Bond' },
        { label: 'Address', value: '3019 Ersel Street Venus, TX 76084' },
        { label: 'Mobile Number', value: '+91 914-366-1459' },
        { label: 'Email', value: 'JemsBond007@armyspy.com' },
        { label: 'GSTIN', value: '29ABCDE1234F1Z5' }
    ];
    const toInfoData = [
        { label: 'Name', value: 'My Business' },
        { label: 'Address', value: '417 Edgewood Road Memphis, TN 38115' },
        { label: 'Mobile Number', value: '+91 914-366-1459' },
        { label: 'GSTIN', value: '123456789000' }
    ];
    const columns = [
        { header: '#', tableText: 'srno' },
        { header: 'Item', tableText: 'item' },
        { header: 'Description', tableText: 'description' },
        { header: 'Provider', tableText: 'provider' },
        { header: 'Unit Price', tableText: 'unitPrice' },
        { header: 'Quantity', tableText: 'quantity' },
        { header: 'Discount', tableText: 'discount' },
        { header: 'Discount Amount', tableText: 'discountAmount' },
        { header: 'Tax', tableText: 'tax' },
        { header: 'Tax Amount', tableText: 'taxAmount' },
        { header: 'Total', tableText: 'total' }
    ];
    const data = [
        { srno: 1, item: 'Service', description: 'Text 001', provider: 'Provider 1', unitPrice: '5200', quantity: '1.00', discount: '', discountAmount: '', tax: '18(Inc)', taxAmount: '793.22', total: '5200' }
    ];
    const totalSummaryData = [
        { totalSummaryTitle: 'Sub Total', totalSummaryAmount: '5200' },
        { totalSummaryTitle: 'Discount', totalSummaryAmount: '0' },
        { totalSummaryTitle: 'Campaign', totalSummaryAmount: '0' },
        { totalSummaryTitle: 'Loyalty', totalSummaryAmount: '0' },
        { totalSummaryTitle: 'Taxable Amount', totalSummaryAmount: '4406.78' },
        { totalSummaryTitle: 'CGST', totalSummaryAmount: '396.61' },
        { totalSummaryTitle: 'SGST', totalSummaryAmount: '396.61' },
        { totalSummaryTitle: 'Total Tax Amount', totalSummaryAmount: '793.22' },
        { totalSummaryTitle: 'Grand Total', totalSummaryAmount: '5200' },
        { totalSummaryTitle: 'Payment Type', totalSummaryAmount: 'Cash' },
        { totalSummaryTitle: 'Amount Received', totalSummaryAmount: '5200' },
        { totalSummaryTitle: 'Amount Due', totalSummaryAmount: '0' },
        { totalSummaryTitle: 'Amount Repaid', totalSummaryAmount: '0' }
    ];
    const invoiceNotesData = [
        { invoiceNotesText: "Note Text" }
    ]
    // Add Invoice modal
    const [invoiceModalShow, setInvoiceModalShow] = useState(false);
    const handleShowInvoice = () => setInvoiceModalShow(true);
    const handleCloseInvoice = () => setInvoiceModalShow(false);

    return (
        <>
            <Card>
                <Card.Body>
                    <Row sm={2} lg={3} xl={4} xxl={5} className='row-cols-1 justify-content-center align-items-center'>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Total Rows : 51</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Total Invoice Amt : 785991.00</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Total Taxable Amt : 110721.93</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Total Tax Amt : 1007.72</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Total Non Taxable Amt : 16285.00</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Cash : 544380</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Bank : 214219</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Due : 23261</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Credit Card : 1000</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='border shadow-none text-center'>
                                <Card.Body>
                                    <h5 className='mb-0 fs-17 fw-medium'>Paytm : 1781</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Table responsive bordered className='table-nowrap' id='mainDatatableViewInvoices'>
                        <thead className='table-light'></thead>
                    </Table>
                </Card.Body>
            </Card>

            {/* View Invoice Modal */}
            <ViewInvoice invoiceTitle="View Invoice" invoiceShow={invoiceModalShow} handleCloseInvoice={handleCloseInvoice} columns={columns} data={data} fromInfo={fromInfoData} toInfo={toInfoData} totalSummary={totalSummaryData} invoiceNotes={invoiceNotesData} />
        </>
    )
}
